import {LOGIN_USER, LOGOUT_USER} from '.';
import {LoginPayloadParams, LoginUserAction, LogoutUserAction} from '../mappers/AuthTypesMapper';

export const logoutUser = (
  dispatch: (action: LogoutUserAction) => void
): void => {
  dispatch({
    type: LOGOUT_USER
  });
};

export const loginUser = (
  dispatch: (action: LoginUserAction) => void,
  params: LoginPayloadParams
  ): void => {
  dispatch({
    type: LOGIN_USER,
    payload: params
  });
};
